import React, { useEffect, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import {BrowserRoute, Routes, Route, BrowserRouter, Link} from 'react-router-dom';
import { connect } from "./redux/blockchain/blockchainActions";
import { fetchData } from "./redux/data/dataActions";
import * as s from "./styles/globalStyles";
import styled from "styled-components";
import "./App.css";

import { CountdownCircleTimer } from "react-countdown-circle-timer";

import Web3 from "web3";
import Web3Modal from "web3modal";
import WalletConnectProvider from "@walletconnect/web3-provider";

const providerOptions = {
  walletconnect: {
    package: WalletConnectProvider,
    options: {
      infuraId: '9aa3d95b3bc440fa88ea12eaa4456161'
    },
    network: "mainnet"
  }
};

const web3Modal = new Web3Modal({
  cacheProvider: false,
  providerOptions // required
});

const truncate = (input, len) =>
  input.length > len ? `${input.substring(0, len)}...` : input;



export const MintLogo = styled.img`
  max-width: 50%;  
  height: auto; 
  margin-bottom: -2%;
  margin-top: -3%;
  @media (min-width: 300px) {
    max-width: 75%;  
  }
  @media (min-width: 1200px) {
    max-width: 50%;  
  }
  
`;

export const GifLogo = styled.img`
  
  @media (min-width: 300px) {
    max-width: 90%;  
  }
  @media (min-width: 1200px) {
    max-width: 50%;  
  }
  max-width: 50%;  
  height: auto; 
  border-radius: 50px;
  border: none;
  
`;
export const UmbriaImage = styled.img`
  
  margin-left: 6%;
  max-width: 100%;  
  height: auto; 
  border-radius: 50px;
  border: none;
  
`;

export const MintPanel = styled.div`
  width: 55%;
  height: 50%;
  padding-top: 2%;
  padding-bottom: 2%;
  padding-left: 1.5%;
  border-radius: 50px;
  border: none;
  background-color: var(--primary-text);
  box-shadow: 0px 6px 0px -2px rgba(250, 250, 250, 0.3);
  -webkit-box-shadow: 0px 6px 0px -2px rgba(250, 250, 250, 0.3);
  -moz-box-shadow: 0px 6px 0px -2px rgba(250, 250, 250, 0.3);
  :active {
    box-shadow: none;
    -webkit-box-shadow: none;
    -moz-box-shadow: none;
  }
  @media (min-width: 300px) {
    width: 85%;  
    padding-left: 8%;
    padding-top: 8%;
    margin-top: 7%;

  }
  @media (min-width: 375px) {
    width: 85%;  
    padding-left: 8%;
    padding-top: 8%;
    margin-top: 5%;

  }
  @media (min-width: 390px) {
    width: 85%;  
    padding-left: 8%;
    padding-top: 8%;
    margin-top: 8%;

  }
  @media (min-width: 820px) {
    width: 85%;  
    padding-left: 8%;
    padding-top: 8%;
    margin-top: 3%;

  }
  @media (min-width: 1200px) {
    width: 55%;  
    padding-left: 1.5%;
    padding-top: 2%;
    margin-top: 0%;
  }
  

`;

export const MsgContainer = styled.p`
@media (min-width: 1000px) {
  
  margin-left: -30px;
}
@media (min-width: 1980px) {
  
  margin-left: -30px;
  font-size: 2.5em;
}
  color: #1dff1d;
  
  margin-left: 1%;
  font-size: 1.75em;
  padding-bottom:5px;
  

`;
export const TimeContainer = styled.p`
  
  color: var(--primary);  
  font-size: 1em;
  margin-top: 40%;
  @media (min-width: 320px) {
    margin-top: 30%;  
    font-size: 0.8em;
    padding-bottom: 5%;
    margin-left: -6px;
  }
  @media (min-width: 375px) {
    margin-top: 24%;  
    font-size: 0.9em;
    padding-bottom: 5%;
    margin-left: -6px;
  }
  @media (min-width: 400px) {
    margin-top: 24%;  
    font-size: 1em;
    padding-bottom: 5%;
    margin-left: -6px;
  }
  @media (min-width: 700px) {
    margin-top: 20%;  
    font-size: 1.5em;
    padding-bottom: 5%;
    margin-left: -6px;
  }
  
  @media (min-width: 820px) {
    margin-top: 15%;  
    font-size: 1.5em;
    padding-bottom: 5%;
    margin-left: -6px;
  }
  @media (min-width: 1000px) {
    margin-top: 15%;  
    font-size: 1.5em;
    padding-bottom: 4%;
    margin-left: -10px;
  }
  @media (min-width: 1200px) {
    margin-top: 43%;  
    font-size: 1.1em;
    padding-bottom: 5%;
    margin-left: -25px;
  }
  @media (min-width: 1980px) {
    margin-top: 50%;  
    font-size: 1.75em;
    padding-bottom: 5%;
    margin-left: 0px;
  }
  
  

`;
export const MsgWrapper = styled.div`
  width:45%;
  float: right;
  text-align: center;
  margin-right: 2%;
  @media (min-width: 300px) {
    width: 100%;  
 

  }
  @media (min-width: 1200px) {
    width: 45%;  

  }
  
`;

export const StyledButton = styled.button`
  @media (min-width: 320px) {
    margin-right: 26%; 

  }
  @media (min-width: 375px) {
    margin-right: 28%; 

  }
  @media (min-width: 390px) {
    margin-right: 30%; 

  }
  @media (min-width: 400px) {
    margin-right: 31%; 

  }
  @media (min-width: 540px) {
    margin-right: 36%; 

  }
  @media (min-width: 700px) {
    margin-right: 35%; 
    font-size: 1.25em;
    width: 175px;

  }
  @media (min-width: 820px) {
    margin-right: 36%; 
    font-size: 1.25em;
    width: 175px;

  }
  @media (min-width: 1000px) {
    margin-right: 41%; 

  }
  @media (min-width: 1200px) {
    margin-right: 25%; 
    margin-top: 10%;

  }
  @media (min-width: 1980px) {
    margin-right: 25%; 
    margin-top: 15%;
    font-size: 2em;
    width: 250px;

  }
  float: right;
  margin-top: 2%;
  margin-right: 29%;
  margin-bottom: 5%;
  padding: 10px;
  border-radius: 50px;
  border: none;
  background-color: #1dff1d;
  padding: 10px;
  font-weight: bold;
  color: var(--primary-text);
  width: 125px;
  cursor: pointer;
  box-shadow: 0px 6px 0px -2px rgba(250, 250, 250, 0.3);
  -webkit-box-shadow: 0px 6px 0px -2px rgba(250, 250, 250, 0.3);
  -moz-box-shadow: 0px 6px 0px -2px rgba(250, 250, 250, 0.3);
  :active {
    box-shadow: none;
    -webkit-box-shadow: none;
    -moz-box-shadow: none;
  }
`;

export const MintButton = styled.button`
  @media (min-width: 320px) {
    margin-right: 28%; 

  }
  @media (min-width: 360px) {
    margin-right: 29%; 

  }
  @media (min-width: 375px) {
    margin-right: 30%; 

  }
  @media (min-width: 390px) {
    margin-right: 32%; 

  }
  @media (min-width: 412px) {
    margin-right: 33%; 

  }
  @media (min-width: 540px) {
    margin-right: 38%; 

  }
  @media (min-width: 712px) {
    margin-right: 36%; 
    font-size: 1.25em;
    width: 175px;

  }
  @media (min-width: 820px) {
    margin-right: 36%; 
    font-size: 1.25em;
    width: 175px;

  }
  @media (min-width: 1000px) {
    margin-right: 41%; 

  }
  @media (min-width: 1200px) {
    margin-right: 25%; 
    margin-top: 10%;

  }
  @media (min-width: 1980px) {
    margin-right: 27%; 
    margin-top: 15%;
    font-size: 2em;
    width: 250px;

  }
  float: right;
  margin-top: 2%;
  margin-right: 29%;
  margin-bottom: 5%;
  padding: 10px;
  border-radius: 50px;
  border: none;
  background-color: #1dff1d;
  padding: 10px;
  font-weight: bold;
  color: var(--primary-text);
  width: 125px;
  cursor: pointer;
  box-shadow: 0px 6px 0px -2px rgba(250, 250, 250, 0.3);
  -webkit-box-shadow: 0px 6px 0px -2px rgba(250, 250, 250, 0.3);
  -moz-box-shadow: 0px 6px 0px -2px rgba(250, 250, 250, 0.3);
  :active {
    box-shadow: none;
    -webkit-box-shadow: none;
    -moz-box-shadow: none;
  }
`;

export const HomeNavButton = styled.button`
  
  margin-bottom: 25px;
  font-size: 1.5em;
  padding: 20px;
  border-radius: 50px;
  border: none;
  background-color: #1dff1d;
  padding: 10px;
  font-weight: bold;
  color: var(--primary-text);
  width: 175px;
  cursor: pointer;
  box-shadow: 0px 6px 0px -2px rgba(250, 250, 250, 0.3);
  -webkit-box-shadow: 0px 6px 0px -2px rgba(250, 250, 250, 0.3);
  -moz-box-shadow: 0px 6px 0px -2px rgba(250, 250, 250, 0.3);
  :active {
    box-shadow: none;
    -webkit-box-shadow: none;
    -moz-box-shadow: none;
  }
`;

export const UmbriaWidget = styled.a`
  
 
  width: 150px;
  cursor: pointer;
  
`;

export const StyledRoundButton = styled.button`
  padding: 10px;
  border-radius: 100%;
  border: none;
  background-color: #ff1d1d;
  padding: 10px;
  font-weight: bold;
  font-size: 30px;
  color: #ffffff;
  width: 30px;
  height: 30px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0px 4px 0px -2px rgba(250, 250, 250, 0.3);
  -webkit-box-shadow: 0px 4px 0px -2px rgba(250, 250, 250, 0.3);
  -moz-box-shadow: 0px 4px 0px -2px rgba(250, 250, 250, 0.3);
  :active {
    box-shadow: none;
    -webkit-box-shadow: none;
    -moz-box-shadow: none;
  }
`;

export const IncrementWrapper = styled.div`

  margin-right: 5%;

`;
export const ScreenContainer = styled.div`

  background-repeat: no-repeat;
  background-image: url("/config/images/gumballheader.jpeg");
  background-position: 10% 0px;
  background-size: 100% 75%;
  width: 100%;
  height: 100%;

`;

export const UmbriaText = styled.p`
  font-size: 20px;
  font-weight: bold;
  background-color: #1dffff;
`;


function App() {
  const dispatch = useDispatch();
  const blockchain = useSelector((state) => state.blockchain);
  const data = useSelector((state) => state.data);
  const [claimingNft, setClaimingNft] = useState(false);
  const [hasConnected, setHasConnected] = useState(false);
  const [showConnect, setShowConnect] = useState(true);
  const [showMint, setShowMint] = useState(false);
  const [feedback, setFeedback] = useState(blockchain.account);
  const [mintAmount, setMintAmount] = useState(1);
  const [web3, setWeb3] = useState(null);
  const [connectText, setConnectText] = useState("Connect");
  const [CONFIG, SET_CONFIG] = useState({
    CONTRACT_ADDRESS: "",
    SCAN_LINK: "",
    NETWORK: {
      NAME: "",
      SYMBOL: "",
      ID: 0,
    },
    NFT_NAME: "",
    SYMBOL: "",
    MAX_SUPPLY: 1,
    WEI_COST: 0,
    DISPLAY_COST: 0,
    GAS_LIMIT: 0,
    MARKETPLACE: "",
    MARKETPLACE_LINK: "",
    SHOW_BACKGROUND: false,
  });

  const claimNFTs = () => {
    let cost = 3000000000000000000;
    let gasLimit = 3000000;
    let totalCostWei = String(cost * mintAmount);
    let totalGasLimit = String(gasLimit * mintAmount);
    console.log("Cost: ", totalCostWei);
    console.log("Gas limit: ", totalGasLimit);
    setFeedback(`Minting your ${CONFIG.NFT_NAME}...`);
    setClaimingNft(true);
    blockchain.smartContract.methods
      .mint(mintAmount)
      .send({
        gasLimit: String(totalGasLimit),
        to: CONFIG.CONTRACT_ADDRESS,
        from: blockchain.account,
        value: totalCostWei,
      })
      .once("error", (err) => {
        console.log(err);
        setFeedback("Sorry, something went wrong please try again later.");
        setClaimingNft(false);
      })
      .then((receipt) => {
        console.log(receipt);
        setFeedback(
          `WOW, congrats on the new ${CONFIG.NFT_NAME}!`
        );
        setClaimingNft(false);
        dispatch(fetchData(blockchain.account));
      });
  };

  const getNFTs = () => {
    
    blockchain.smartContract.methods
      .walletOfOwner(String(blockchain.account))
      .call({
        from: blockchain.account
      })
      .then((receipt) => {
        console.log(receipt);
        for(const i = 0; i < receipt; i++){
          console.log(receipt[i]);
          getMetaData(receipt[i]);
        }
      });
  };
  
  const calculateTimeLeft = () => {
    
    let difference = +new Date("Febuary 16, 2022 15:00:00 EST") - +new Date();

    let timeLeft = {};

    if (difference > 0) {
      timeLeft = {
        days: Math.floor(difference / (1000 * 60 * 60 * 24)),
        hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
        minutes: Math.floor((difference / 1000 / 60) % 60),
        seconds: Math.floor((difference / 1000) % 60)
      };
    }

    return timeLeft;
  };
  
  const [timeLeft, setTimeLeft] = useState(calculateTimeLeft());

  useEffect(() => {
    const timer = setTimeout(() => {
      setTimeLeft(calculateTimeLeft());
    }, 1000);
    return () => clearTimeout(timer);
  });
  
  const timerComponents = [];

  Object.keys(timeLeft).forEach((interval) => {
    if (!timeLeft[interval]) {
      return;
    }
  
    timerComponents.push(
      <span>
        {timeLeft[interval]} {interval}{". "}
      </span>
    );
  });

  const decrementMintAmount = () => {
    let newMintAmount = mintAmount - 1;
    if (newMintAmount < 1) {
      newMintAmount = 1;
    }
    setMintAmount(newMintAmount);
  };

  const incrementMintAmount = () => {
    let newMintAmount = mintAmount + 1;
    if (newMintAmount > 20) {
      newMintAmount = 20;
    }
    setMintAmount(newMintAmount);
  };

  const getData = () => {
    if (blockchain.account !== "" && blockchain.smartContract !== null) {
      dispatch(fetchData(blockchain.account));
    }
  };

  const getConfig = async () => {
    const configResponse = await fetch("/config/config.json", {
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    });
    const config = await configResponse.json();
    SET_CONFIG(config);
  };



  useEffect(() => {
    getConfig();
  }, []);

  useEffect(() => {
    getData();
  }, [blockchain.account]);


  const Home = () => {
    return (
      <s.Screen>
        <s.Container
          flex={1}
          ai={"center"}
          
          image={"/config/images/gumballheader1.jpeg"}
          style={{ backgroundColor: "#97edec"}}
        >   
        
          <MintLogo alt={"logo"} src={"/config/images/logo.png"} />
          <s.SpacerLarge />
          <a href="https://opensea.io/collection/the-gumball-gang"><HomeNavButton>OpenSea</HomeNavButton></a>
          <Link to="Mint"><HomeNavButton>Mint</HomeNavButton></Link>
          <a href="https://twitter.com/GumballGangNft"><HomeNavButton>Twitter</HomeNavButton></a>

          <UmbriaWidget href={"https://widget.umbria.network/swap"}><UmbriaImage alt={"logo"} src={"/config/images/umbria.png"} /></UmbriaWidget>
          <s.SpacerSmall />
          <UmbriaText>"Powered by the Umbria Network!"</UmbriaText>
          
        </s.Container>   
      </s.Screen>
    );
  };
  
  const Mint = () => {
    return (
      <s.Screen>
        <s.Container
          flex={1}
          ai={"center"}
          style={{ backgroundColor: "#97edec" }}
          image={CONFIG.SHOW_BACKGROUND ? "/config/images/gumballheader.jpeg" : null}
        >   
        
          <MintLogo alt={"logo"} src={"/config/images/logo.png"} />
          <MintPanel>
            <GifLogo alt={"logo"} src={"/config/images/gumballgang.gif"} />
            <MsgWrapper>
              <s.SpacerLarge />
              <MsgContainer>Supply: {hasConnected ? data.totalSupply + " / " : null} 10,000</MsgContainer>
              <MsgContainer>Blockchain: Polygon</MsgContainer>
              <MsgContainer>Cost: 3 Matic</MsgContainer>
              <s.SpacerLarge />
  
              {showMint ? <IncrementWrapper>
              <s.Container   ai={"center"} jc={"center"} fd={"row"}>
                <StyledRoundButton
                  style={{ lineHeight: 0.4 }}
                  disabled={claimingNft ? 1 : 0}
                  onClick={(e) => {
                    e.preventDefault();
                    decrementMintAmount();
                  }}
                >
                  -
                </StyledRoundButton>
                <s.SpacerMedium />
                <s.TextDescription
                  style={{
                    textAlign: "center",
                    color: "var(--accent-text)",
                  }}
                >
                  {mintAmount}
                </s.TextDescription>
                <s.SpacerMedium />
                <StyledRoundButton
                  disabled={claimingNft ? 1 : 0}
                  onClick={(e) => {
                    e.preventDefault();
                    incrementMintAmount();
                  }}
                >
                  +
                </StyledRoundButton>
                
              </s.Container>
              </IncrementWrapper>: null}
              <s.SpacerLarge />
              {showConnect ? <StyledButton 
                onClick={(e) => {
                  e.preventDefault();
                  web3Modal.clearCachedProvider();
                  web3Modal.connect().then((connectedProvider) => {
                    dispatch(connect(connectedProvider));
                    getData();
                    setHasConnected(true);
                    setShowConnect(false);
                    setShowMint(true);
                    
                    
                  });
                }}
  
                
              >
                Connect
              </StyledButton> : null}
              {showMint ? <MintButton
                disabled={claimingNft ? 1 : 0}
                onClick={(e) => {
                  e.preventDefault();
                  claimNFTs();
                  getData();
                }}
              >
                {claimingNft ? "MINTING" : "MINT"} 
              </MintButton> : null}
              <TimeContainer>{feedback}</TimeContainer>
            </MsgWrapper>
          </MintPanel>
          
        </s.Container>   
      </s.Screen>
    );

  };


  

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={ <Home/> } />
        <Route path="/mint" element={ <Mint/> } /> 
      </Routes>
    </BrowserRouter>
  );
}

export default App;
